module.exports = __webpack_public_path__ + "media/images/emblems/Morges-coat_of_arms-56d2ac30422b0b8ba4eda16296d2914f.svg";